export const TRANSLATIONS_EN_HOME_ACTIONS_AND_OVERVIEW = {
  "home.title": "Retrieval-Augmented Generation System",
  "home.lead":
    "Enhance language model answers with contextual information from your documents.",
  "home.description":
    "Upload documents, make queries, and get accurate answers based on your own information.",
  "home.upload_btn": "Upload Documents",
  "home.query_btn": "Make Query",
  "home.feature_processing_title": "Document Processing",
  "home.feature_processing_desc":
    "Extract text from PDF, Word, and TXT documents stored in S3 or uploaded directly.",
  "home.feature_embeddings_title": "Embeddings and Vectorization",
  "home.feature_embeddings_desc":
    "Convert text into vectors using advanced embedding models for semantic search.",
  "home.feature_generation_title": "Answer Generation",
  "home.feature_generation_desc":
    "Get accurate answers based on your documents using advanced language models.",
  "home.general.loading": "Loading telemetry...",
  "home.general.retry": "Retry",
  "home.general.retryAfter": "Retrying in",
  "home.general.actionUnavailableTitle": "Action unavailable",
  "home.general.actionUnavailableMessage": "We don't have enough information to complete this action.",
  "home.pagination.previous": "Previous",
  "home.pagination.next": "Next",
  "home.shared.aiBadge": "AI-generated signal",
  "home.shared.detectedBadge": "Auto-detected",
  "home.shared.prioritizedBadge": "AI-prioritized",
  "home.shared.recommendationBadge": "Recommended next step",
  "home.reasonCode.due_soon": "Due soon",
  "home.reasonCode.overdue": "Overdue",
  "home.reasonCode.high_priority": "High priority",
  "home.reasonCode.compliance_required": "Compliance required",
  "home.reasonCode.needs_review": "Needs review",
  "home.reasonCode.pending_review": "Pending review",
  "home.decisionStates.act_now": "Act now",
  "home.decisionStates.act_soon": "Act soon",
  "home.decisionStates.act_without_rush": "Can wait",
  "home.decisionStates.waiting": "Scheduled action",
  "home.decisionStates.blocked": "Waiting on information",
  "home.decisionStates.in_review": "In review",
  "home.decisionStates.dismissed": "Dismissed",
  "home.decisionStates.safe_to_ignore": "Safe to ignore",
  "home.decisionStates.completed": "Resolved",
  "home.attention.sectionTitle": "Needs attention",
  "home.attention.followUpTitle": "Follow-up",
  "home.attention.allClearTitle": "All clear",
  "home.attention.allClearCopy": "Nothing needs your attention right now.",
  "home.decisionDisplay.priority.critical.label": "Critical",
  "home.decisionDisplay.priority.critical.copy": "It is overdue or could create operational impact.",
  "home.decisionDisplay.priority.high.label": "High",
  "home.decisionDisplay.priority.high.copy": "The date is close and needs review.",
  "home.decisionDisplay.priority.medium.label": "Medium",
  "home.decisionDisplay.priority.medium.copy": "It should be reviewed soon to avoid blockers or delays.",
  "home.decisionDisplay.priority.low.label": "Low",
  "home.decisionDisplay.priority.low.copy": "It can remain under observation for now.",
  "home.decisionDisplay.risk.critical.label": "Critical risk",
  "home.decisionDisplay.risk.critical.copy": "It can interrupt an important operation or create immediate non-compliance.",
  "home.decisionDisplay.risk.high.label": "High risk",
  "home.decisionDisplay.risk.high.copy": "It can affect payments, compliance, or operational continuity.",
  "home.decisionDisplay.risk.medium.label": "Medium risk",
  "home.decisionDisplay.risk.medium.copy": "It can create delays, rework, or follow-up effort.",
  "home.decisionDisplay.risk.low.label": "Low risk",
  "home.decisionDisplay.risk.low.copy": "Operational impact stays limited if it is reviewed on time.",
  "home.decisionDisplay.risk.none.label": "Risk to confirm",
  "home.decisionDisplay.risk.none.copy": "There is not enough context to rate the risk yet.",
  "home.decisionDisplay.confidence.high.label": "High confidence",
  "home.decisionDisplay.confidence.high.copy": "The recommendation is consistent with the available evidence.",
  "home.decisionDisplay.confidence.medium.label": "Medium confidence",
  "home.decisionDisplay.confidence.medium.copy": "Review the key evidence before confirming.",
  "home.decisionDisplay.confidence.low.label": "Low confidence",
  "home.decisionDisplay.confidence.low.copy": "Review the evidence before acting.",
  "home.decisionActionUx.readyTitle": "You can act now",
  "home.decisionActionUx.readyCopy": "This decision is ready for its next action.",
  "home.decisionActionUx.completeMissingInfo": "Review missing information",
  "home.decisionActionUx.missingInfoTitle": "Required information is missing",
  "home.decisionActionUx.missingInfoCopy": "Review the missing information in this panel and complete the data in the source document or system before retrying the action.",
  "home.decisionActionUx.missingInfoReason": "The final action stays blocked until that data exists in the source.",
  "home.decisionActionUx.reviewEvidence": "Review evidence",
  "home.decisionActionUx.lowConfidenceTitle": "This recommendation needs review",
  "home.decisionActionUx.lowConfidenceCopy": "The decision should not run until the evidence and confidence have been reviewed.",
  "home.decisionActionUx.lowConfidenceReason": "Confidence is too low to run the final action.",
  "home.decisionActionUx.reviewRecommendation": "Review recommendation",
  "home.decisionActionUx.catalogTitle": "The recommendation needs validation",
  "home.decisionActionUx.catalogCopy": "The decision source is not stable enough to run the final action.",
  "home.decisionActionUx.catalogReason": "The recommendation degraded and requires manual review.",
  "home.decisionActionUx.resolveBlock": "View blocker",
  "home.decisionActionUx.blockedTitle": "Urgent, but blocked",
  "home.decisionActionUx.blockedCopy": "This decision matters now, but it cannot be completed until the blocker is resolved.",
  "home.decisionActionUx.blockedReason": "Resolve the blocker before running the final action.",
  "home.decisionActionUx.waitingLabel": "Wait for update",
  "home.decisionActionUx.waitingTitle": "You cannot act yet",
  "home.decisionActionUx.waitingCopy": "This decision depends on an external signal or a pending update.",
  "home.decisionActionUx.waitingReason": "Home IA is still waiting for the condition that enables this action.",
  "home.decisionActionUx.confirmRequiredData": "Confirm required data",
  "home.decisionActionUx.reviewRequirements": "Review requirements",
  "home.decisionActionUx.disabledTitle": "The action is not available",
  "home.decisionActionUx.disabledCopy": "This decision needs review before the main action can be re-enabled.",
  "home.decisionActionUx.completedTitle": "Decision resolved",
  "home.decisionActionUx.completedCopy": "There is no pending action for this decision.",
  "home.decisionActionUx.completedReason": "This decision has already been resolved.",
  "home.decisionActionUx.safeToIgnoreTitle": "No action required now",
  "home.decisionActionUx.safeToIgnoreCopy": "You can keep this decision under observation without intervening.",
  "home.decisionActionUx.safeToIgnoreReason": "This decision can stay under monitoring without immediate action.",
  "home.decisionActionUx.noActionTitle": "No confirmed action",
  "home.decisionActionUx.noActionCopy": "There is no confirmed action for this decision yet.",
  "home.decisionSummary.eyebrow": "States",
  "home.decisionSummary.title": "Decision summary",
  "home.decisionList.eyebrow": "Inbox",
  "home.decisionList.title": "Compact decision list",
  "home.decisionList.filteredTitle": "Filtered decisions",
  "home.decisionList.empty": "There are no decisions to show yet.",
  "home.decisionList.emptyFiltered": "There are no decisions in this state.",
  "home.viewMode.current": "Current view",
  "home.viewMode.calendar": "Calendar",
  "home.decisionActionForm.title": "Required input",
  "home.decisionActionForm.selectPlaceholder": "Select an option",
  "home.decisionActionForm.required": "Complete this field to continue.",
  "home.decisionActionForm.confirmExecution": "I confirm this operational action should run.",
  "home.decisionActionForm.confirmRequired": "Confirm the action before continuing.",
  "home.decisionActionForm.submit": "Run action",
  "home.decisionActionForm.cancel": "Cancel",
};
